var _defs, _rect, _animateMotion, _animateMotion2, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    id: "svg8",
    height: 100,
    viewBox: "0 0 200 100",
    "data-app": "Xyris",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    strokeWidth: 0,
    x: 0,
    y: 0,
    width: 200,
    height: 100
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(0, 193, 255)",
    stroke: "#000000",
    strokeWidth: 0,
    "transform-origin": "center",
    style: {
      transformBox: "fill-box"
    },
    x: -238.209,
    y: 42.1251,
    width: 146.348,
    height: 164.314,
    transform: "matrix(0.8191520442889918,0.573576436351046,-0.573576436351046,0.8191520442889918,112.2939453125,-112.07086849212646)"
  }, _animateMotion || (_animateMotion = /*#__PURE__*/React.createElement("animateMotion", {
    begin: -0.00001,
    dur: 0.4800200000000001,
    keyTimes: "0; 1",
    keyPoints: "0; 1.0",
    fill: "freeze",
    keySplines: "0.32 0.01 0.58 1",
    calcMode: "spline"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#motion-path-4mn6r9xmxnMfHjBJgX6HBp"
  })))), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(0, 193, 255)",
    stroke: "#000000",
    strokeWidth: 0,
    "transform-origin": "center",
    style: {
      transformBox: "fill-box"
    },
    x: -43.0573,
    y: 17.2189,
    width: 23.9321,
    height: 128.455,
    transform: "matrix(0.8191520442889918,0.573576436351046,-0.573576436351046,0.8191520442889918,12.659950256347656,-39.447930335998535)"
  }, _animateMotion2 || (_animateMotion2 = /*#__PURE__*/React.createElement("animateMotion", {
    begin: 0.23999,
    dur: 0.527686870117187,
    keyTimes: "0; 1",
    keyPoints: "0; 1.0",
    fill: "freeze",
    keySplines: "0.32 0.01 0.58 1",
    calcMode: "spline"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#motion-path-an73XFiRPqufjCCbLu5Eha"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-97)",
    "transform-origin": ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect121680",
    fillOpacity: 1,
    strokeWidth: "0.999999px",
    strokeOpacity: 0,
    d: "M -0.000519112 -3.70568 L -0.000519112 374.247 L 755.905 374.247 L 755.905 -3.70568 L -0.000519112 -3.70568 Z M 37.1968 105.673 L 335.671 105.675 L 335.671 163.653 L 335.671 163.819 L 335.855 163.819 L 377.597 201.644 L 419.339 163.819 L 420.661 163.819 L 420.661 105.673 L 712.736 105.673 L 690.009 139.589 L 567.28 139.589 L 567.28 147.821 L 684.493 147.821 L 666.095 175.278 L 540.007 175.278 L 540.007 183.507 L 660.579 183.507 L 638.786 216.03 L 511.485 216.03 L 511.485 224.259 L 633.271 224.259 L 606.603 264.056 L 606.603 264.857 L 143.868 264.857 L 116.54 224.071 L 238.774 224.071 L 238.774 215.839 L 111.02 215.839 L 89.2319 183.321 L 210.249 183.321 L 210.249 175.087 L 83.7124 175.087 L 65.314 147.632 L 182.976 147.632 L 182.976 139.398 L 59.7983 139.398 L 37.1968 105.673 Z",
    transform: "matrix(0.2645833194255829,0,0,0.26987483382225036,0,97)",
    fill: "rgb(0, 0, 0)",
    "transform-origin": ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -6.511343515349836 29.23298180103302 C 199.48865648465016 27.66098129749298 200 28.42799949645996 200 28.42799949645996",
    strokeWidth: 1,
    stroke: "none",
    fill: "none",
    id: "motion-path-an73XFiRPqufjCCbLu5Eha"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M -39.8507 29.233 C 325.695 29.233 325.695 29.233 325.695 29.233",
    strokeWidth: 1,
    stroke: "none",
    fill: "rgb(254, 254, 51)",
    id: "motion-path-4mn6r9xmxnMfHjBJgX6HBp",
    fillOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b7482b5e4eeeac2984b63991659dc5f.svg";
export { ForwardRef as ReactComponent };